<template>
  <confirmation-prompt
    id="no-lib-prompt"
    :show="show"
    :title="noLiBPromptTitle"
    :info-text="noLiBPromptText"
    :extra-wide="true"
    :cancel-button-show="false"
    :confirm-button-show="false"
    @close="close"
  >
  </confirmation-prompt>
</template>

<script>
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import CheckExpectedDeliveryDatePurchaseOrder from '@/mixins/checkExpectedDeliveryDatePurchaseOrder.js'

export default {
  // Use CheckExpectedDeliveryDatePurchaseOrder mixin with any component using this prompt
  components: {
    ConfirmationPrompt,
  },
  mixins: [CheckExpectedDeliveryDatePurchaseOrder],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    extraWide: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      labelPrefix: '/expected delivery date/error',
    }
  },
  computed: {
    noLiBPromptTitle() {
      return this.i18n.t(`${this.labelPrefix}/title`)
    },
    noLiBPromptText() {
      return this.i18n.t(`${this.labelPrefix}/purchaseordertext`)
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style></style>
